/**
 * @param {HTMLInputElement} clickedCheckboxInput
 * @return {HTMLInputElement[]}
 */
function getChildCheckboxInputsOfTermsFilter(clickedCheckboxInput) {
    // Need .js-filter-checkbox element as
    // child checkboxes are placed inside of sibling ul element
    let jsFilterCheckbox = clickedCheckboxInput.parentNode;
    while (!jsFilterCheckbox.classList.contains('js-filter-checkbox') && jsFilterCheckbox.parentNode)
        jsFilterCheckbox = jsFilterCheckbox.parentNode;

    const childCheckboxInputs = [...jsFilterCheckbox.parentNode.querySelectorAll('.js-filter-checkbox + ul .js-filter-checkbox input[type=checkbox]')];

    return childCheckboxInputs;
}

/**
 * @param {HTMLInputElement} clickedCheckboxInput
 * @return {HTMLInputElement[]}
 */
function getParentCheckboxInputsOfTermsFilter(clickedCheckboxInput) {
    const parentCheckboxInputs = [];

    let jsFilterCheckbox = clickedCheckboxInput.parentNode;
    while (!jsFilterCheckbox.classList.contains('js-filter-checkbox') && jsFilterCheckbox.parentNode)
        jsFilterCheckbox = jsFilterCheckbox.parentNode;

    let parentNode = jsFilterCheckbox.parentNode.parentNode;
    while (!parentNode.classList.contains('js-terms-filter') && parentNode.parentNode) {
        for (const childNode of parentNode.children) {
            if (childNode.classList.contains('js-filter-checkbox'))
                parentCheckboxInputs.push(childNode.querySelector('input[type=checkbox]'));
        }
        parentNode = parentNode.parentNode;
    }

    return parentCheckboxInputs;
}

/**
 * @param {HTMLInputElement[]} childCheckboxInputs
 * @param {boolean} newCheckedState
 * @return {void}
 */
function setStateToChildCheckboxInputs(childCheckboxInputs, newCheckedState) {
    for (const checkbox of childCheckboxInputs) {
        checkbox.checked = newCheckedState;
    }
}

/**
 * @param {HTMLInputElement[]} parentCheckboxInputs
 * @param {boolean} newCheckedState
 * @return {void}
 */
function setStateToParentCheckboxInputs(parentCheckboxInputs, newCheckedState) {
    for (const checkbox of parentCheckboxInputs) {
        checkbox.checked = newCheckedState && getChildCheckboxInputsOfTermsFilter(checkbox).every(checkbox => checkbox.checked);
    }
}

/**
 * Toggles checked state of clicked checkbox,
 * updates states of child and parent checkboxes
 * and returns array of all the affected checkboxes
 * @param {HTMLInputElement} clickedCheckboxInput
 * @return {HTMLInputElement[]}
 */
export function toggleHierarchicalTermsFilterState(clickedCheckboxInput) {
    const newCheckedState = !clickedCheckboxInput.checked;
    const childCheckboxInputs = getChildCheckboxInputsOfTermsFilter(clickedCheckboxInput);
    const parentCheckboxInputs = getParentCheckboxInputsOfTermsFilter(clickedCheckboxInput);

    clickedCheckboxInput.checked = newCheckedState;
    setStateToChildCheckboxInputs(childCheckboxInputs, newCheckedState);
    setStateToParentCheckboxInputs(parentCheckboxInputs, newCheckedState);

    return [clickedCheckboxInput, ...childCheckboxInputs, ...parentCheckboxInputs];
}